import store from "@/store";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { upsertMomentLocale } from "@/utils/moment-config";

export const featureKey = "i18n";

// @ts-ignore
if (store.state.i18n) {
  store.unregisterModule(featureKey);
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true
})
export class I18nStoreModule extends VuexModule {
  private _locales: LocaleSelectorType[] = [
    { value: "en", text: "EN", flag: require("@/assets/images/flags/en.png") },
    { value: "ptBr", text: "PT-BR", flag: require("@/assets/images/flags/ptBr.png") }
  ];

  private _locale: LocaleSelectorType = this.setDefaultLocale();

  setDefaultLocale(): LocaleSelectorType {
    upsertMomentLocale("pt-br");
    return this._locales[1];
  }

  @Mutation
  setSelectedLocale(locale: LocaleSelectorType) {
    this._locale = locale;
    switch (locale.value) {
      case "en":
        upsertMomentLocale("en-us");
        break;
      case "ptBr":
        upsertMomentLocale("pt-br");
        break;
    }
  }

  @Action({ commit: "setSelectedLocale", rawError: true })
  onChangeLocale(locale: LocaleSelectorType) {
    return locale;
  }

  get locales(): LocaleSelectorType[] {
    return this._locales;
  }

  get locale(): LocaleSelectorType {
    return this._locale;
  }
}

export interface LocaleSelectorType {
  value: LocaleI18n;
  text: string;
  flag: string;
}

export type LocaleI18n = "en" | "ptBr";
